(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"]) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    if (window.theme && theme.settings && theme.settings.cartType !== 'page') {
      event.preventDefault();
    }
  });

  let highVariantSizeSelected = false;

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!input || !input.hasAttribute('data-product-hot-reload-trigger')) return;
    if ((input.name || '').toLowerCase().includes('size')) {
      highVariantSizeSelected = true;
    }
  });

  document.addEventListener('product-hot-reload:updated', (event) => {
    if (!highVariantSizeSelected || !event.detail || !event.detail.element) return;
    const button = event.detail.element.querySelector('.abh');
    if (button) button.classList.add('active');
  });

  document.addEventListener('product-form:submit:success', (event) => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      detail: {
        product: event.detail ? event.detail.response : null,
        addToCartBtn: event.target ? event.target.querySelector('[data-add-to-cart]') : null
      }
    }));
  });

  } catch(e) { console.error(e); }
})();
})();
